import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  orderSummary: {
    flex: 1,
    height: 'fit-content',
    padding: '16px 24px',
  },
  selectedProductsDetailsList: {
    flexDirection: 'column',
    padding: '24px 0',
  },
  orderSummaryRows: {
    '&>.line1 p': { color: theme.evPalette.charcoal[900] },
    '&>.line2>p': { color: theme.evPalette.charcoal[700] },
    gap: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  promoCodeLabel: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    color: theme.evPalette.charcoal[700],
    marginBottom: '10px',
  },
  promoCodeInput: {
    maxWidth: '172px',
    '&>*:first-child': { height: '44px' },
    '& >.Mui-error': { backgroundColor: theme.evPalette.rose[100] },
    '& >.Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
  },
  promoInputHelperText: {
    '&.Mui-error': { backgroundColor: 'unset' },
    color: `${theme.evPalette.rose[900]} !important`,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    marginLeft: 0,
    marginTop: '10px',
  },
  applyBtn: {
    width: '85px',
    backgroundColor: theme.evPalette.ocean[900],
    color: theme.evPalette.salt[100],
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0',
    rowGap: '24px',
    '&:empty': { paddingBottom: 0 },
  },
  tax: {
    padding: 0,
    rowGap: '8px',
  },
  estimatedTotal: {
    borderTop: `1px solid ${theme.evPalette.charcoal[500]}`,
    borderBottom: `1px solid ${theme.evPalette.charcoal[500]}`,
    padding: '20px 0px',
    '& *': {
      color: theme.evPalette.charcoal[900],
      fontWeight: 600,
    },
  },
  terms: {
    '&>p': {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: theme.evPalette.charcoal[900],
    },
  },
  buttonContainer: {
    rowGap: '16px',
    flexDirection: 'column',
    '&>button': {
      flex: 1,
    },
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
      '&>button': {
        flex: 'unset',
      },
    },
  },
  button: {
    height: '44px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
  },
}));
